module.exports = __webpack_public_path__ + "img/deep-sky.6272e018.png";